import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../environments/environment';
import { faAngleLeft, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Location, NgIf } from '@angular/common';
import { NgbNav, NgbTooltip, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../auth.service';
import { User } from '../user';
import { SettingsSubscriptionsComponent } from '../settings-subscriptions/settings-subscriptions.component';
import { SettingsPaymentsComponent } from '../settings-payments/settings-payments.component';
import { SettingsEmailsComponent } from '../settings-emails/settings-emails.component';
import { SettingsInvoicesComponent } from '../settings-invoices/settings-invoices.component';
import { SettingsProposalsComponent } from '../settings-proposals/settings-proposals.component';
import { SettingsProjectsComponent } from '../settings-projects/settings-projects.component';
import { SettingsUsersComponent } from '../settings-users/settings-users.component';
import { SettingsOrganizationComponent } from '../settings-organization/settings-organization.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { SettingsCommunicationsComponent } from '@main/sms-call/settings-communications/settings-communications.component';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    imports: [NgIf, FaIconComponent, NgbTooltip, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, SettingsOrganizationComponent, SettingsUsersComponent, SettingsProjectsComponent, SettingsProposalsComponent, SettingsInvoicesComponent, SettingsCommunicationsComponent, SettingsEmailsComponent, SettingsPaymentsComponent, SettingsSubscriptionsComponent, NgbNavOutlet]
})
export class SettingsComponent implements OnInit, AfterViewInit {

  // Properties
  version: string = environment.version;
  @ViewChild('nav') private nav: NgbNav;
  user: User = null;

  // Font Awesome Properties
  faAngleLeft = faAngleLeft;
  faTriangleExclamation = faTriangleExclamation;

  constructor(
    public location: Location,
    private authService: AuthService
  ) { }

  async ngOnInit(): Promise<void> {
    this.user = JSON.parse(localStorage.getItem('login'));
  }

  ngAfterViewInit(): void {
    this.nav.activeIdChange.subscribe((activeId) => {
      sessionStorage.setItem('settingsNavActiveId', activeId);
    });
  }

  // Get Current Tab
  getCurrentTab(): string {
    let activeId = sessionStorage.getItem('settingsNavActiveId');
    return (activeId === undefined) ? 'ORGANIZATION' : activeId;
  }

  proceedToSubscriptionTab(event) {
    if (event) {
      sessionStorage.setItem('settingsNavActiveId', 'SUBSCRIPTIONS');
      sessionStorage.setItem('isSubOpen', 'true');
      this.getCurrentTab();
    }
  }
}
